import { useCallback, useRef } from 'react'
import { createPreloadImage } from '../Image/utils'

export const usePreloadBusinessImages = (): {
  preloadOnce: (src: string, width: number, height: number, alt: string) => void;
} => {
  const preloadedImageSrcsRef = useRef<Set<string>>(new Set())

  const preloadOnce =
     useCallback((src: string, width: number, height: number, alt: string): void => {
       if (typeof window === 'undefined') {
         return
       }

       const { src: preloadSrc } = createPreloadImage({ src, width, height, alt })

       if (!preloadSrc || preloadedImageSrcsRef.current.has(preloadSrc)) {
         return
       }
       preloadedImageSrcsRef.current.add(preloadSrc)

       const image = new Image()

       image.onerror = () => {
         preloadedImageSrcsRef.current.delete(preloadSrc)
       }
       image.src = preloadSrc
     }, [])

  return {
    preloadOnce
  }
}
